import { Section } from '@/components/shared';
import { Auth } from '@aws-amplify/auth';
import { Flex, Icon, Link, Text } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import { IoPaperPlaneOutline } from 'react-icons/io5';
import { useSearchParams } from 'react-router-dom';

export const CheckEmailMessage: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const userEmail: string | null = searchParams.get('name');

  const handleResendConfirmation = (): void => {
    if (userEmail) {
      Auth.resendSignUp(userEmail)
        .then(() => console.log('code resent successfully'))
        .catch((error) => console.log('error resending code', error));
    } else {
      console.log('there was a problem on collecting user email');
    }
  };

  return (
    <Section
      containerProps={{ py: 0, gap: { base: 8, md: 16 } }}
      headingProps={{ mt: 0 }}
      id="check-signup-email-message"
    >
      <Flex
        alignItems="center"
        direction="column"
        gap={6}
        px={{ base: 0, md: 16, xl: 44 }}
        py={{ base: 10, md: 24 }}
      >
        <Icon as={IoPaperPlaneOutline} h={20} w={20} />
        <Text fontSize={{ base: 'h1.base', md: 'h1.mb' }} fontWeight="bold" textAlign="center">
          {t('LOGIN.RECOVER_PASSWORD_CHECK')}
        </Text>
        <Text fontSize={{ base: 'p.base', md: 'p.mb' }} textAlign="center">
          <Trans
            components={{
              url: (
                <Link
                  color="brand.red.light"
                  fontWeight="bold"
                  onClick={handleResendConfirmation}
                />
              ),
            }}
            i18nKey={'SIGNUP.CONFIRM_EMAIL_PAGE.MESSAGE'}
          />
        </Text>
      </Flex>
    </Section>
  );
};
